import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout';
import LoginLayout from '@/layout/loginLayout';
import headerLayout from '@/layout/headerLayout';
import i18n from '@/i18n/index';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/',
        children: [
            {
                path: '/',
                component: () => import('@/views/home/index'),
                name: 'Home',
                meta: {
                    title:
                        i18n.t('message.router.globalLeadingPlatform') +
                        ' | Poynex',
                    needLogin: true
                }
            },
            {
                path: '/home/finance/index/:menuTab',
                meta: {
                    title: `${i18n.t('message.home.subscribe')} | Poynex`
                },
                component: () => import('@/views/home/finance/index'),
                name: 'Finance'
            },
            {
                path: '/home/finance/log',
                meta: {
                    title: `${i18n.t('message.home.buyRecords')} | Poynex`
                },
                component: () => import('@/views/home/financeLog/index'),
                name: 'FinanceLog'
            },
            // 理财
            {
                path: '/home/management/index',
                meta: {
                    title: `${i18n.t('message.header.manage')} | Poynex`
                },
                component: () => import('@/views/home/manageFinances/index'),
                name: 'management'
            },
            // 理财账号记录
            {
                path: '/home/automatic/log',
                meta: {
                    title: `${i18n.t('message.home.buyRecords')} | Poynex`
                },
                component: () => import('@/views/home/automaticLog/index'),
                name: 'AutomaticLog'
            }
        ]
    },
    {
        path: '/login',
        component: LoginLayout,
        redirect: '/login',
        children: [
            {
                path: '/',
                component: () => import('@/views/login/index'),
                name: 'Login',
                meta: {
                    title: `${i18n.t('message.common.login')} | Poynex`,
                    needLogin: true
                }
            },
            {
                path: 'safeVerify',
                component: () => import('@/views/login/safeVerify'),
                name: 'SafeVerify',
                meta: {
                    title: `${i18n.t('message.user.safeVei')} | Poynex`,
                    needLogin: true
                }
            },
            {
                path: 'tips',
                name: 'Tips',
                meta: {
                    title: `${i18n.t('message.common.tips')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/login/forget/tips')
            },
            {
                path: 'forget',
                name: 'Forget',
                meta: {
                    title: `${i18n.t('message.user.forgetP')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/login/forget/index')
            },
            {
                path: 'forget/reset',
                name: 'Reset',
                meta: {
                    title: `${i18n.t('message.user.forgetP')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/login/forget/reset')
            },
            {
                path: 'forget/success',
                name: 'Success',
                meta: {
                    title: `${i18n.t('message.user.forgetP')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/login/forget/success')
            }
        ]
    },
    {
        path: '/register',
        component: LoginLayout,
        redirect: '/register',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.common.regis')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/register/index'),
                name: 'Register'
            },
            {
                path: 'accountVerify',
                name: 'AccountVerify',
                meta: {
                    title: `${i18n.t('message.common.regis')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/register/accountVerify')
            },
            {
                path: 'success',
                name: 'RegisSuccess',
                meta: {
                    title: `${i18n.t('message.common.regis')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/register/regisSuccess')
            }
        ]
    },
    {
        path: '/account/security',
        component: Layout,
        // redirect: '/safeCenter',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.header.safe')} | Poynex`
                },
                component: () => import('@/views/safeCenter/index'),
                name: 'SafeCenter'
            }
        ]
    },
    {
        path: '/account',
        component: Layout,
        redirect: '/account/list',
        children: [
            // {
            //   path: 'dashboard',
            //   meta: { title: `${i18n.t('')} | Poynex` '资产 | Poynex' },
            //   component: () => import('@/views/assets/index'),
            //   name: 'Assets'
            // },
            {
                path: 'list',
                meta: {
                    title: `${i18n.t('message.router.assetRecords')} | Poynex`
                },
                component: () => import('@/views/assets/list'),
                name: 'AssetsList'
            }
        ]
    },
    {
        path: '/my/wallet/funding/list',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/assets/list/otcList'),
                name: 'OtcAssetsList',
                meta: {
                    title: `${i18n.t('message.router.assetFlow')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account/detail',
        component: Layout,
        children: [
            {
                path: ':coin',
                component: () => import('@/views/assets/list/detail'),
                name: 'AssetsDetail',
                meta: {
                    title: `${i18n.t('message.assets.assetDetails')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account',
        component: Layout,
        children: [
            {
                path: ':account',
                component: () => import('@/views/assets/index'),
                name: 'Wallet',
                meta: {
                    title: `${i18n.t('message.header.walletMenuItem1')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account/main/deposit/crypto',
        component: Layout,
        children: [
            {
                path: ':coin',
                component: () => import('@/views/assets/recharge'),
                name: 'Recharge',
                meta: {
                    title: `${i18n.t('message.assets.recharge')} - ${i18n.t('message.header.wallet')} | Poynex`
                }
            },
            {
                path: 'Blockchain/:coin',
                component: () => import('@/views/assets/blockchainRecharge'),
                name: 'BlockchainRecharge',
                meta: {
                    title: `${i18n.t('message.assets.recharge')} - ${i18n.t('message.header.wallet')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account/main/deposit/prepare',
        component: Layout,
        children: [
            {
                path: '/',
                component: () =>
                    import('@/views/assets/deposit-prepare/index.vue'),
                name: 'Recharge',
                meta: {
                    title: `${i18n.t('message.common.bankCard')} | Poynex`
                }
            },
            {
                path: 'Blockchain/:coin',
                component: () => import('@/views/assets/blockchainRecharge'),
                name: 'BlockchainRecharge',
                meta: {
                    title: `${i18n.t('message.assets.recharge')} - ${i18n.t('message.header.wallet')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account/main/deposit/prepare',
        component: Layout,
        children: [
            {
                path: '/',
                component: () =>
                    import('@/views/assets/deposit-prepare/index.vue'),
                name: 'Recharge',
                meta: {
                    title: `${i18n.t('message.common.bankCard')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/my/wallet/account/main/withdraw/crypto',
        component: Layout,
        children: [
            {
                path: ':coin',
                component: () => import('@/views/assets/withdraw'),
                name: 'Withdraw',
                meta: {
                    title: `${i18n.t('message.assets.withdraw')} - ${i18n.t('message.header.wallet')} | Poynex`
                }
            },
            {
                path: '/bankCashDetail',
                component: () => import('@/views/assets/bankCash'),
                name: 'bankCashDetail',
                meta: {
                    title: `${i18n.t('message.assets.withdraw')} - ${i18n.t('message.header.wallet')} | Poynex`
                }
            },
            {
                path: '/deposit-prepare/:tranType',
                component: () =>
                    import('@/views/assets/deposit-prepare/index.vue'),
                name: 'deposit-prepare',
                meta: {
                    title: `${i18n.t('finance_deposit')} - ${i18n.t('message.header.walletMenuItem5')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/withdrawAddress',
        component: Layout,
        children: [
            {
                path: '',
                component: () => import('@/views/assets/withdrawAddress'),
                name: 'withdrawAddress',
                meta: {
                    title: `${i18n.t('message.assets.withdraw')}`
                }
            }
        ]
    },
    {
        path: '/my/wallet',
        component: Layout,
        children: [
            {
                path: ':account',
                component: () => import('@/views/assets/index'),
                name: 'Funding',
                meta: {
                    title: `${i18n.t('message.assets.amount')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/account/kyc/personal',
        component: Layout,
        // redirect: '/authenticate',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.user.verify')} | Poynex`
                },
                component: () => import('@/views/authenticate/index'),
                name: 'Authenticate'
            }
        ]
    },
    {
        path: '/markets',
        component: Layout,
        // redirect: '/quotes',
        children: [
            {
                path: ':type',
                component: () => import('@/views/quotes/index'),
                name: 'Quotes',
                meta: {
                    title: `${i18n.t('message.quotes.center')} | Poynex`
                }
            }
        ]
    },
    {
        path: '/referral',
        component: Layout,
        // redirect: '/invite',
        children: [
            {
                path: '',
                meta: {
                    title: `${i18n.t('message.header.invite')} | Poynex`
                },
                component: () => import('@/views/invite/index'),
                name: 'Invite'
            }
        ]
    },
    {
        path: '/inmail',
        component: Layout,
        // redirect: '/stationLetter',
        children: [
            {
                path: '',
                meta: {
                    title: `${i18n.t('message.notice.title')} | Poynex`
                },
                component: () => import('@/views/stationLetter/index'),
                name: 'StationLetter'
            }
        ]
    },
    {
        path: '/download',
        component: Layout,
        // redirect: '/download',
        children: [
            {
                path: '',
                meta: {
                    title: `${i18n.t('message.router.appDownload')} | Poynex`
                },
                component: () => import('@/views/download/index'),
                name: 'Download'
            }
        ]
    },
    {
        path: '/order/spot',
        component: Layout,
        // redirect: '/order/exchangeOrder',
        children: [
            {
                path: ':orderType',
                meta: {
                    title: `${i18n.t('message.header.spotOrder')} | Poynex`
                },
                component: () => import('@/views/spot/order/index'),
                name: 'SpotOrder'
            }
        ]
    },
    {
        path: '/spot',
        component: headerLayout,
        children: [
            {
                path: ':tradePair',
                meta: {
                    title: `${i18n.t('message.footer.spotDeal')} | Poynex`
                },
                component: () => import('@/views/spot/transaction/index'),
                name: 'Transaction'
            }
        ]
    },
    {
        path: '/futures',
        component: headerLayout,
        children: [
            {
                path: ':tradePair',
                meta: {
                    title: `${i18n.t('message.router.contractTrading')} | Poynex`
                },
                component: () => import('@/views/futures/trade/index'),
                name: 'FuturesTrade'
            }
        ]
    },
    {
        path: '/futures/order',
        component: Layout,
        children: [
            {
                path: ':orderType',
                meta: {
                    title: `${i18n.t('message.futures.futOrder')} | Poynex`
                },
                component: () => import('@/views/futures/order/index'),
                name: 'FuturesOrder'
            }
        ]
    },
    {
        path: '/delivery',
        component: headerLayout,
        children: [
            {
                path: ':tradePair',
                meta: {
                    title: `${i18n.t('message.router.contractTrading')} | Poynex`
                },
                component: () => import('@/views/delivery/trade/index'),
                name: 'DeliveryTrade'
            }
        ]
    },
    {
        path: '/delivery/order',
        component: Layout,
        children: [
            {
                path: ':orderType',
                meta: {
                    title: `${i18n.t('message.futures.futOrder')} | Poynex`
                },
                component: () => import('@/views/delivery/order/index'),
                name: 'DeliveryOrder'
            }
        ]
    },
    {
        path: '/fee',
        component: Layout,
        redirect: '/fee/trade',
        children: [
            {
                path: 'trade',
                meta: {
                    title: `${i18n.t('message.footer.rate')} | Poynex`
                },
                component: () => import('@/views/footer/help/rate/trade'),
                name: 'TradeRate'
            },
            {
                path: 'cryptoFee',
                meta: {
                    title: `${i18n.t('message.footer.rate')} | Poynex`
                },
                component: () => import('@/views/footer/help/rate/cryptoFee'),
                name: 'CryptoFee'
            }
        ]
    },
    {
        path: '/apiKey',
        component: Layout,
        // redirect: '/download',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.router.apiKeyManagement')} | Poynex`
                },
                component: () => import('@/views/apiKey/index'),
                name: 'ApiKey'
            }
        ]
    },
    {
        path: '/help',
        component: Layout,
        redirect: '/help',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.footer.help')} | Poynex`
                },
                component: () => import('@/views/help/index'),
                name: 'Help'
            },
            {
                path: '/articleList',
                meta: {
                    title: `${i18n.t('message.common.commonProblem')} | Poynex`
                },
                component: () => import('@/views/help/articleList'),
                name: 'ArticleList'
            },
            {
                path: '/articleDetail',
                meta: {
                    title: `${i18n.t('message.common.commonProblem')} | Poynex`
                },
                component: () => import('@/views/help/articleDetail'),
                name: 'ArticleDetail'
            },
            {
                path: '/search',
                meta: {
                    title: `${i18n.t('message.spot.search')} | Poynex`
                },
                component: () => import('@/views/help/search'),
                name: 'Search'
            }
        ]
    },
    {
        path: '/buy',
        component: Layout,
        redirect: '/buy/fast',
        children: [
            {
                path: 'fast',
                meta: {
                    title: `${i18n.t('message.header.quickCoin')} | Poynex`
                },
                component: () => import('@/views/buyCoins/buyFast'),
                name: 'BuyFast'
            },
            {
                path: 'custorm',
                meta: {
                    title: `${i18n.t('message.router.customBuyCoins')} | Poynex`
                },
                component: () => import('@/views/buyCoins/buyCustorm'),
                name: 'BuyCustorm'
            },
            {
                path: 'order',
                meta: {
                    title: `${i18n.t('message.buyCoinsC.myOrders')} | Poynex`
                },
                component: () => import('@/views/buyCoins/order'),
                name: 'Order'
            },
            {
                path: 'order_detail',
                meta: {
                    title: `${i18n.t('message.router.orderDetails')} | Poynex`
                },
                component: () => import('@/views/buyCoins/orderDetail/index'),
                name: 'OrderDetail'
            },
            {
                path: 'order_pay',
                meta: {
                    title: `${i18n.t('message.header.quickCoin')} | Poynex`
                },
                component: () => import('@/views/buyCoins/orderPay'),
                name: 'OrderPay'
            },
            {
                path: 'pay_method',
                meta: {
                    title: `${i18n.t('message.buyCoins.collectionWay')} | Poynex`
                },
                component: () => import('@/views/buyCoins/payMethod'),
                name: 'PayMethod'
            },
            {
                path: 'business_info',
                meta: {
                    title: `${i18n.t('message.router.merchantHomepage')} | Poynex`
                },
                component: () => import('@/views/buyCoins/businessInfo'),
                name: 'BusinessInfo'
            },
            {
                path: 'business_manager',
                meta: {
                    title: `${i18n.t('message.buyCoinsKYC.merchantDashboard')} | Poynex`
                },
                component: () => import('@/views/buyCoins/businessManager'),
                name: 'BusinessManager'
            },
            {
                path: 'business_ad',
                meta: {
                    title: `${i18n.t('message.buyCoinsKYC.merchantDashboard')} | Poynex`
                },
                component: () =>
                    import('@/views/buyCoins/businessManager/businessAd'),
                name: 'BusinessAd'
            },
            {
                path: 'apply_business',
                meta: {
                    title: `${i18n.t('message.router.applyMerchant')} | Poynex`
                },
                component: () => import('@/views/buyCoins/applyBusiness'),
                name: 'ApplyBusiness'
            },
            {
                path: 'apply_business_form',
                meta: {
                    title: `${i18n.t('message.router.applyMerchant')} | Poynex`
                },
                component: () =>
                    import('@/views/buyCoins/applyBusiness/applyBusinessForm'),
                name: 'ApplyBusinessForm'
            }
        ]
    },
    {
        path: '/transfer',
        component: Layout,
        redirect: '/transfer',
        children: [
            {
                path: '/',
                meta: {
                    title: `${i18n.t('message.TransferMoney.title')} | Poynex`
                },
                component: () => import('@/views/transferMoney/index'),
                name: 'TransferMoney'
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        // redirect: '/footer/aboutUs',
        children: [
            {
                path: ':menuType',
                meta: {
                    title: `${i18n.t('message.footer.aboutUs')} | Poynex`,
                    needLogin: true
                },
                component: () => import('@/views/footer/aboutUs/index'),
                name: 'AboutUs'
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

// eslint-disable-next-line
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

export default router;
